// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xfq5","colMin":"styles_colMin__JdG01"};